import { CdkStepperModule } from '@angular/cdk/stepper';
import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import { MatStepper, MatStepperModule } from '@angular/material/stepper';
import { Router } from '@angular/router';
import { I18NextModule } from 'angular-i18next';
import { StorageService } from 'src/app/core/storage/storage.service';
import { ApproversComponent } from 'src/app/shared/components/approvers/approvers.component';
import { RequestType } from 'src/app/shared/model/requestType.enum';
import { AuthorizerUsers, User } from 'src/app/shared/model/user.model';

@Component({
  standalone: true,
  selector: 'app-step-approvers',
  templateUrl: './step-approvers.component.html',
  styleUrls: ['./step-approvers.component.scss'],
  imports: [
    CommonModule,
    I18NextModule,
    ApproversComponent,
    MatStepperModule,
    CdkStepperModule
  ]
})
export class StepApproversComponent implements OnInit, OnChanges {
  @Input() requestType!: string;
  @Input() user!: User;
  @Input() loanType?: string;
  @Input() resetStep = false;
  @Input() moreThan14days = false;
  @Input() stepper!: MatStepper;

  @Output() authorizerControllerEmitter = new EventEmitter<any>();
  @Output() backStepEmitter = new EventEmitter();
  @Output() approversEmitter = new EventEmitter();

  requestTypeEnum = RequestType;
  controller?: AuthorizerUsers;
  authorizer?: AuthorizerUsers;
  showController?: boolean;
  showAuthorizer?: boolean;

  landing2 = false;

  constructor(
    private router: Router,
    private storageService: StorageService
  ) {}

  ngOnInit() {
    this.landing2 = this.storageService.get('landing2') || false;
  }

  onSelectionAuthorizers(event: {
    controller: AuthorizerUsers;
    authorizer: AuthorizerUsers;
  }) {
    this.controller = event.controller;
    this.authorizer = event.authorizer;
    this.authorizerControllerEmitter.emit(event);
  }

  onShowApprovers(event: { showController: boolean; showAuthorizer: boolean }) {
    this.showController = event.showController;
    this.showAuthorizer = event.showAuthorizer;
  }

  sendApprovers() {
    this.approversEmitter.emit();
  }

  getButtonStyle(): string {
    if (
      this.showController &&
      this.showAuthorizer &&
      (this.isControllerIdEmpty() || this.isAuthorizerIdEmpty())
    ) {
      return 'background-color: #565554';
    } else if (this.showAuthorizer && this.isAuthorizerIdEmpty()) {
      return 'background-color: #565554';
    } else if (this.showController && this.isControllerIdEmpty()) {
      return 'background-color: #565554';
    }
    return 'background-color: #2c2a29';
  }

  isButtonDisabled(): boolean {
    if (this.showController && this.showAuthorizer) {
      return this.isControllerIdEmpty() || this.isAuthorizerIdEmpty();
    } else if (this.showAuthorizer) {
      return this.isAuthorizerIdEmpty();
    } else if (this.showController) {
      return this.isControllerIdEmpty();
    }
    return false;
  }

  isControllerIdEmpty(): boolean {
    return !this.controller?.id || this.controller.id === '';
  }

  isAuthorizerIdEmpty(): boolean {
    return !this.authorizer?.id || this.authorizer.id === '';
  }

  backStep() {
    this.stepper?.selectedIndex === 0
      ? this.landing2
        ? this.router.navigateByUrl('/landing-leasing')
        : this.router.navigateByUrl('/menu')
      : this.backStepEmitter.emit();
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes['resetStep']?.currentValue) {
      this.authorizerControllerEmitter.emit({
        controller: this.controller,
        authorizer: this.authorizer
      });
    }
  }
}
